export default "__VITE_ASSET__C8kY2mW$__"